// @flow
import * as React from 'react'
import PropTypes from 'prop-types'
import { BrowserRouter } from 'react-router-dom'
import SegmentPager from './SegmentPager'

type Props = {
  children: React.Node,
}

export default class WonderschoolRouter extends React.Component<Props> {
  static childContextTypes = {
    useReactRouterLink: PropTypes.bool.isRequired,
  }

  getChildContext = () => {
    return {
      useReactRouterLink: true,
    }
  }

  render() {
    return (
      <BrowserRouter>
        <SegmentPager>{this.props.children}</SegmentPager>
      </BrowserRouter>
    )
  }
}
